module.exports = __webpack_public_path__ + "img/bomb_ios_802.png";